



















import { Component, Vue } from "vue-property-decorator";
import ToolService from "@/services/tool-service";
import { Tool } from "./Tool";

@Component
export default class Sidebar extends Vue {
  private toolType = Tool;
  private activeTool = Tool.Add;
  private colorPicker: any = {};

  private mounted() {
    this.colorPicker = document.getElementById("paintColor") as HTMLInputElement;
  }

  private enableTool(type: Tool): void {
    this.activeTool = type;
    ToolService.$emit("enableTool", type);
  }

  private changeColor(event: any): void {
    ToolService.$emit("changeColor", this.colorPicker.value);
  }

  private openPopUp(): void {
    this.$emit("openPopUp");
  }
}
